import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.993 7.821v6.843c0 1.662 1.51 2.932 3.486 2.932h7.028c1.975 0 3.486-1.27 3.486-2.932V7.821zM0 18.574h20c0 1.08-.895 1.955-2 1.955H2c-1.105 0-2-.875-2-1.955M16.993 7.821v6.808C18.669 14.387 20 12.937 20 11.242c0-1.857-1.507-3.42-3.007-3.42M16.5 12.71c-.8 0-1.5-.685-1.5-1.467s.7-1.466 1.5-1.466q.257.001.493.088c.574.209 1.007.763 1.007 1.378s-.433 1.17-1.007 1.378a1.4 1.4 0 0 1-.493.088zM8 5.377c0 .54-.448.977-1 .977s-1-.437-1-.977c0-1.43.704-2.556 2.021-3.258.81-.432 1.313-.935 1.553-1.51.208-.5.792-.74 1.303-.537a.97.97 0 0 1 .55 1.274c-.428 1.025-1.258 1.855-2.448 2.49C8.296 4.2 8 4.674 8 5.377m4.952.3a1.005 1.005 0 0 1-1.258.63.973.973 0 0 1-.646-1.23c.267-.812 1.029-1.474 2.242-2.089.756-.383 1.135-.796 1.232-1.238A1 1 0 0 1 15.71 1c.54.112.883.632.768 1.16-.237 1.078-1.024 1.933-2.268 2.564-.787.4-1.192.75-1.258.952"
    }, null, -1)
  ]))]))
}
export default { render: render }